import http from '../services/http';

import {
    ADMIN_CREATE_COURSE_ENDPOINT,
    ADMIN_ALL_COURSES_ENDPOINT,
    ADMIN_COURSES_OVERVIEW_ENDPOINT,
    ADMIN_UPDATE_COURSE_ENDPOINT,
    ADMIN_DELETE_COURSE_ENDPOINT,
    GET_ONE_COURSE_ENDPOINT,
    ALL_COURSES_ENDPOINT,
    GET_ALL_ELEARNING_ENDPOINT,
    GET_RESOURSE_PACK_SEARCH_RESULTS,
    ALL_COURSES_AND_ELEARNING_ENDPOINT,
    generateEndpoint,
} from './endpoints';
import {ADMIN_CREATE_ELEARNING_COURSE_ENDPOINT, ADMIN_UPDATE_ELEARNING_COURSE_ENDPOINT} from "./endpoints";

export default (() => {

    const getOne = (id) => {

        var endpoint = generateEndpoint(GET_ONE_COURSE_ENDPOINT, { id });

        return http.get(endpoint);
    };

    const getAll = () => {

        return http.get(ADMIN_ALL_COURSES_ENDPOINT);
    };

    const getAllCourses = () => {

        return http.get(ALL_COURSES_ENDPOINT);
    };

    const getAllCoursesAndElearning = () => {

        return http.get(ALL_COURSES_AND_ELEARNING_ENDPOINT);
    };

    const getAdminOverview = (filters) => {

        return http.get(ADMIN_COURSES_OVERVIEW_ENDPOINT, { params: filters });
    };
    
    const create = (courseParams) => {

        return http.post(ADMIN_CREATE_COURSE_ENDPOINT, courseParams);
    };

    const createELearning = (courseParams) => {

        return http.post(ADMIN_CREATE_ELEARNING_COURSE_ENDPOINT, courseParams);
    };

    const update = (courseParams) => {

        var endpoint = generateEndpoint(ADMIN_UPDATE_COURSE_ENDPOINT, { id: courseParams.id });

        return http.put(endpoint, courseParams);
    };

    const updateELearning = (courseParams) => {

        var endpoint = generateEndpoint(ADMIN_UPDATE_ELEARNING_COURSE_ENDPOINT, { id: courseParams.id });

        return http.put(endpoint, courseParams);
    };

    const remove = (courseId) => {

        var endpoint = generateEndpoint(ADMIN_DELETE_COURSE_ENDPOINT, { id: courseId });

        return http.delete(endpoint);
    };

    const getAdminELearning = () => {
        return http.get(GET_ALL_ELEARNING_ENDPOINT);
    }

    const searchResourcePacks = params => {
        return http.get(GET_RESOURSE_PACK_SEARCH_RESULTS, {params: params});
    }
    
    return {
        create,
        createELearning,
        update,
        updateELearning,
        remove,
        getAll,
        getAllCourses,
        getAllCoursesAndElearning,
        getOne,
        getAdminOverview,
        getAdminELearning,
        searchResourcePacks
    };

})();


// WEBPACK FOOTER //
// ./services/courses.js